export default __webpack_public_path__ + "static/media/dash-icon-settings.64b243ce.svg";